// extracted by mini-css-extract-plugin
module.exports = {"navbar-container":"Footer_navbar-container__2Korz","navbar":"Footer_navbar__2DH50","site-title":"Footer_site-title__2_awY","social":"Footer_social__1xBi9"};